const zod = require('zod');

const envSchema = zod.object({
  NEXT_PUBLIC_ENV: zod.enum(['local', 'dev', 'prod']),
  NEXT_PUBLIC_ORDER_SERVICE_API: zod.string().url(),
  NEXT_PUBLIC_MSV2_API: zod.string().url(),
  NEXT_PUBLIC_USERS_SERVICE_API: zod.string().url(),
  NEXT_PUBLIC_GCS_API: zod.string().url(),
  NEXT_PUBLIC_RMA_SERVICE_API: zod.string().url(),
  NEXT_PUBLIC_WHOOP_API: zod.string().url(),
  NEXT_PUBLIC_STRIPE_KEY: zod.string(),
  NEXT_PUBLIC_STRIPE_EU_KEY: zod.string(),
  NEXT_PUBLIC_JOIN_URL: zod.string().url(),
  NEXT_PUBLIC_UPGRADE_URL: zod.string().url(),
  NEXT_PUBLIC_TRY_URL: zod.string().url(),
  NEXT_PUBLIC_WHOOP_URL: zod.string().url(),
  NEXT_PUBLIC_APP_URL: zod.string().url(),
  NEXT_PUBLIC_ORDER_STATUS_URL: zod.string().url(),
  NEXT_PUBLIC_MS_SUPPORT_URL: zod.string().url(),
  CONTENTFUL_GRAPHQL_BASE_URL: zod.string().url(),
  CONTENTFUL_DELIVERY_TOKEN: zod.string(),
  CONTENTFUL_SPACE_ID: zod.string(),
  CONTENTFUL_PREVIEW: zod.enum(['enabled', 'disabled']),
  CONTENTFUL_ENVIRONMENT: zod.string(),
  CONTENTFUL_ENVIRONMENT_WHOOP_COM: zod.string(),
  CONTENTFUL_DELIVERY_TOKEN_WHOOP_COM: zod.string(),
  CONTENTFUL_SPACE_ID_WHOOP_COM: zod.string(),
  DATADOG_LOGS_KEY: zod.string(),
  NEXT_PUBLIC_PRODUCT_SERVICE_API: zod.string().url(),
  NEXT_PUBLIC_COMMERCE_SERVICE_API: zod.string().url(),
  NEXT_PUBLIC_AMPLITUDE_API_KEY: zod.string(),
  NEXT_PUBLIC_SEGMENT_API_KEY: zod.string(),
  NEXT_PUBLIC_GTM_ID: zod.string(),
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: zod.string(),
  NEXT_PUBLIC_SHOPIFY_BASE_URL: zod.string().url(),
  NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN: zod.string(),
  NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID: zod.string(),
  NEXT_PUBLIC_DD_APP_ID: zod.string(),
  NEXT_PUBLIC_DD_CLIENT_TOKEN: zod.string(),
  NEXT_PUBLIC_E2E_URL: zod.string().url(),
  NEXT_PUBLIC_SENTRY_DSN: zod.string(),
  NEXT_PUBLIC_CACHE_SECRET: zod.string(),
  NEXT_PUBLIC_SMARTY_API_KEY: zod.string(),
  NEXT_PUBLIC_JOIN_FLIPKART_URL: zod.string().url(),
  NEXT_PUBLIC_JF_REPLATFORM_URL: zod.string().url(),
  NEXT_PUBLIC_COMMIT_SHA: zod.string(),
  NEXT_PUBLIC_UPGRADES_PAYMENT_METHOD_CONFIGURATION_EU: zod.string(),
  NEXT_PUBLIC_UPGRADES_PAYMENT_METHOD_CONFIGURATION_US: zod.string(),
  NEXT_PUBLIC_BRAZILIAN_AMAZON_STRAP_URL: zod.string().url(),
  ITERABLE_SUBSCRIBE_ACTION: zod.string(),
  NEXT_PUBLIC_TRUEMED_PAYMENT_METHOD_ID: zod.string(),
});

const env = envSchema.parse({
  NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ORDER_SERVICE_API: process.env.NEXT_PUBLIC_ORDER_SERVICE_API,
  NEXT_PUBLIC_MSV2_API: process.env.NEXT_PUBLIC_MSV2_API,
  NEXT_PUBLIC_USERS_SERVICE_API: process.env.NEXT_PUBLIC_USERS_SERVICE_API,
  NEXT_PUBLIC_GCS_API: process.env.NEXT_PUBLIC_GCS_API,
  NEXT_PUBLIC_RMA_SERVICE_API: process.env.NEXT_PUBLIC_RMA_SERVICE_API,
  NEXT_PUBLIC_WHOOP_API: process.env.NEXT_PUBLIC_WHOOP_API,
  NEXT_PUBLIC_STRIPE_KEY: process.env.NEXT_PUBLIC_STRIPE_KEY,
  NEXT_PUBLIC_STRIPE_EU_KEY: process.env.NEXT_PUBLIC_STRIPE_EU_KEY,
  NEXT_PUBLIC_JOIN_URL: process.env.NEXT_PUBLIC_JOIN_URL,
  NEXT_PUBLIC_UPGRADE_URL: process.env.NEXT_PUBLIC_UPGRADE_URL,
  NEXT_PUBLIC_TRY_URL: process.env.NEXT_PUBLIC_TRY_URL,
  NEXT_PUBLIC_WHOOP_URL: process.env.NEXT_PUBLIC_WHOOP_URL,
  NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
  NEXT_PUBLIC_ORDER_STATUS_URL: process.env.NEXT_PUBLIC_ORDER_STATUS_URL,
  NEXT_PUBLIC_MS_SUPPORT_URL: process.env.NEXT_PUBLIC_MS_SUPPORT_URL,
  CONTENTFUL_GRAPHQL_BASE_URL:
    process.env.CONTENTFUL_GRAPHQL_BASE_URL ||
    'https://graphql.contentful.com/content/v1/spaces',
  CONTENTFUL_DELIVERY_TOKEN: process.env.CONTENTFUL_DELIVERY_TOKEN || '',
  CONTENTFUL_SPACE_ID: process.env.CONTENTFUL_SPACE_ID || '',
  CONTENTFUL_PREVIEW: process.env.CONTENTFUL_PREVIEW || 'disabled',
  CONTENTFUL_ENVIRONMENT: process.env.CONTENTFUL_ENVIRONMENT || '',
  CONTENTFUL_DELIVERY_TOKEN_WHOOP_COM:
    process.env.CONTENTFUL_DELIVERY_TOKEN_WHOOP_COM || '',
  CONTENTFUL_SPACE_ID_WHOOP_COM:
    process.env.CONTENTFUL_SPACE_ID_WHOOP_COM || '',
  CONTENTFUL_ENVIRONMENT_WHOOP_COM:
    process.env.CONTENTFUL_ENVIRONMENT_WHOOP_COM || '',
  DATADOG_LOGS_KEY: process.env.DATADOG_LOGS_KEY || '',
  ITERABLE_SUBSCRIBE_ACTION: process.env.ITERABLE_SUBSCRIBE_ACTION || '',
  NEXT_PUBLIC_PRODUCT_SERVICE_API: process.env.NEXT_PUBLIC_PRODUCT_SERVICE_API,
  NEXT_PUBLIC_COMMERCE_SERVICE_API:
    process.env.NEXT_PUBLIC_COMMERCE_SERVICE_API,
  NEXT_PUBLIC_AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
  NEXT_PUBLIC_SEGMENT_API_KEY: process.env.NEXT_PUBLIC_SEGMENT_API_KEY,
  NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
  NEXT_PUBLIC_SHOPIFY_BASE_URL: process.env.NEXT_PUBLIC_SHOPIFY_BASE_URL,
  NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN:
    process.env.NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN,
  NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID:
    process.env.NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID,
  NEXT_PUBLIC_DD_APP_ID: process.env.NEXT_PUBLIC_DD_APP_ID,
  NEXT_PUBLIC_DD_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
  NEXT_PUBLIC_E2E_URL: process.env.NEXT_PUBLIC_E2E_URL,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_CACHE_SECRET: process.env.NEXT_PUBLIC_CACHE_SECRET,
  NEXT_PUBLIC_SMARTY_API_KEY: process.env.NEXT_PUBLIC_SMARTY_API_KEY,
  NEXT_PUBLIC_JOIN_FLIPKART_URL: process.env.NEXT_PUBLIC_JOIN_FLIPKART_URL,
  NEXT_PUBLIC_JF_REPLATFORM_URL: process.env.NEXT_PUBLIC_JF_REPLATFORM_URL,
  NEXT_PUBLIC_COMMIT_SHA: process.env.CIRCLE_SHA1 || '',
  NEXT_PUBLIC_UPGRADES_PAYMENT_METHOD_CONFIGURATION_EU:
    process.env.NEXT_PUBLIC_UPGRADES_PAYMENT_METHOD_CONFIGURATION_EU,
  NEXT_PUBLIC_UPGRADES_PAYMENT_METHOD_CONFIGURATION_US:
    process.env.NEXT_PUBLIC_UPGRADES_PAYMENT_METHOD_CONFIGURATION_US,
  NEXT_PUBLIC_BRAZILIAN_AMAZON_STRAP_URL:
    process.env.NEXT_PUBLIC_BRAZILIAN_AMAZON_STRAP_URL,
  NEXT_PUBLIC_TRUEMED_PAYMENT_METHOD_ID:
    process.env.NEXT_PUBLIC_TRUEMED_PAYMENT_METHOD_ID,
});

module.exports = { env };
